(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-events"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activatePopulatedPreview = () => {
      const previewParams = new URLSearchParams(window.location.hash.slice(1));
      if (previewParams.get('populated_preview') !== '1') return;

      document.querySelectorAll('.events-index--archive').forEach((section) => {
        const template = section.querySelector('[data-events-populated-preview-template]');
        const upcomingPanel = section.querySelector('[data-events-panel="upcoming"]');
        const recapsPanel = section.querySelector('[data-events-panel="recaps"]');
        const emptyState = upcomingPanel?.querySelector('.events-index__empty');

        if (!template || !upcomingPanel || !emptyState) return;

        const preview = template.content.cloneNode(true);
        emptyState.replaceWith(preview);
        section.classList.remove('events-index--archive');
        upcomingPanel.classList.add('is-active');
        recapsPanel?.classList.remove('is-active');

        section.querySelectorAll('[data-events-tab]').forEach((tab) => {
          const isUpcoming = tab.dataset.eventsTab === 'upcoming';
          tab.classList.toggle('is-active', isUpcoming);
          tab.setAttribute('aria-selected', String(isUpcoming));
          tab.tabIndex = isUpcoming ? 0 : -1;
        });

        section.querySelectorAll('[data-events-preview-link]').forEach((link) => {
          link.addEventListener('click', (event) => event.preventDefault());
        });
      });
    };

    activatePopulatedPreview();

    const initializeArchiveSelects = (scope = document) => {
      scope.querySelectorAll('[data-event-archive-select]').forEach((select) => {
        if (select.dataset.initialized === 'true') return;
        select.dataset.initialized = 'true';

        select.addEventListener('change', () => {
          if (select.value) window.location.assign(select.value);
        });
      });
    };

    initializeArchiveSelects();

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const openDisclosure = document.querySelector('[data-event-archive-disclosure][open]');
      if (!openDisclosure) return;

      event.preventDefault();
      openDisclosure.removeAttribute('open');
      openDisclosure.querySelector('summary')?.focus();
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-event-archive-disclosure][open]').forEach((disclosure) => {
        if (!disclosure.contains(event.target)) disclosure.removeAttribute('open');
      });
    });

    const tablists = document.querySelectorAll('[data-events-tabs]');

    tablists.forEach((tablist) => {
      if (tablist.dataset.initialized === 'true') return;
      tablist.dataset.initialized = 'true';

      const root = tablist.closest('.events-index__inner');
      const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[data-events-panel]'));
      const mobileTabs = window.matchMedia('(max-width: 749px)');

      const selectTab = (selectedTab, moveFocus = false) => {
        if (!selectedTab || selectedTab.disabled) return;
        const selectedName = selectedTab.dataset.eventsTab;

        tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isSelected = panel.dataset.eventsPanel === selectedName;
          panel.classList.toggle('is-active', isSelected);
          panel.setAttribute('aria-hidden', String(!isSelected));
        });

        if (moveFocus) selectedTab.focus();
      };

      tablist.addEventListener('click', (event) => {
        if (!mobileTabs.matches) return;
        selectTab(event.target.closest('[role="tab"]'));
      });

      tablist.addEventListener('keydown', (event) => {
        if (!mobileTabs.matches) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        const enabledTabs = tabs.filter((tab) => !tab.disabled);
        const currentIndex = enabledTabs.indexOf(document.activeElement);
        let nextIndex = currentIndex;

        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = enabledTabs.length - 1;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % enabledTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + enabledTabs.length) % enabledTabs.length;

        selectTab(enabledTabs[nextIndex], true);
      });

      const syncResponsiveState = () => {
        if (mobileTabs.matches) {
          selectTab(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true'));
        } else {
          panels.forEach((panel) => panel.removeAttribute('aria-hidden'));
        }
      };

      mobileTabs.addEventListener('change', syncResponsiveState);
      syncResponsiveState();
    });

    const initializeRecapCarousels = (scope = document) => {
      scope.querySelectorAll('[data-recap-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') return;

        const viewport = carousel.querySelector('[data-recap-viewport]');
        const track = carousel.querySelector('[data-recap-track]');
        const carouselShell = carousel.querySelector('.events-index__recap-carousel');
        const cards = Array.from(carousel.querySelectorAll('[data-recap-card]'));
        const previousButton = carousel.querySelector('[data-recap-previous]');
        const nextButton = carousel.querySelector('[data-recap-next]');
        const count = carousel.querySelector('[data-recap-count]');

        if (!viewport || !track || !carouselShell || !previousButton || !nextButton || cards.length === 0) return;
        carousel.dataset.initialized = 'true';

        let visibleCount = 1;
        let currentIndex = 0;
        let scrollFrame = 0;

        const cardOffset = (card) => card.offsetLeft - track.offsetLeft;

        const closestCardIndex = () => {
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          cards.forEach((card, index) => {
            const distance = Math.abs(viewport.scrollLeft - cardOffset(card));
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        };

        const maxStartIndex = () => Math.max(cards.length - visibleCount, 0);

        const pageStops = () => {
          const lastStart = maxStartIndex();
          const stops = [0];

          for (let index = visibleCount; index < lastStart; index += visibleCount) {
            stops.push(index);
          }

          if (lastStart > 0 && stops[stops.length - 1] !== lastStart) stops.push(lastStart);
          return stops;
        };

        const updateState = () => {
          currentIndex = Math.min(closestCardIndex(), maxStartIndex());
          const endIndex = Math.min(currentIndex + visibleCount, cards.length);

          previousButton.disabled = currentIndex === 0;
          nextButton.disabled = currentIndex >= maxStartIndex();

          if (count) {
            const rangeTemplate = count.dataset.rangeTemplate || '__START__–__END__ of __TOTAL__';
            count.textContent = rangeTemplate
              .replace('__START__', String(currentIndex + 1))
              .replace('__END__', String(endIndex))
              .replace('__TOTAL__', String(cards.length));
          }
        };

        const goToCard = (index) => {
          const targetIndex = Math.max(0, Math.min(index, maxStartIndex()));
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          viewport.scrollTo({
            left: cardOffset(cards[targetIndex]),
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        };

        const moveByPage = (direction) => {
          const stops = pageStops();
          const target = direction > 0
            ? stops.find((stop) => stop > currentIndex)
            : stops.slice().reverse().find((stop) => stop < currentIndex);

          if (target !== undefined) goToCard(target);
        };

        const measure = () => {
          if (viewport.clientWidth === 0) return;

          const firstCardWidth = cards[0].getBoundingClientRect().width;
          const trackStyles = window.getComputedStyle(track);
          const gap = Number.parseFloat(trackStyles.columnGap) || 0;
          const measuredVisibleCount = Math.round((viewport.clientWidth + gap) / (firstCardWidth + gap));
          visibleCount = Math.max(1, Math.min(measuredVisibleCount, cards.length));

          const firstMedia = cards[0].querySelector('.events-index__card-media');
          if (firstMedia) {
            const shellRect = carouselShell.getBoundingClientRect();
            const mediaRect = firstMedia.getBoundingClientRect();
            const mediaCenter = mediaRect.top - shellRect.top + (mediaRect.height / 2);
            carouselShell.style.setProperty('--recap-control-top', `${mediaCenter}px`);
          }

          goToCard(Math.min(currentIndex, maxStartIndex()));
          updateState();
        };

        previousButton.addEventListener('click', () => moveByPage(-1));
        nextButton.addEventListener('click', () => moveByPage(1));

        viewport.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          if (event.key === 'ArrowLeft') moveByPage(-1);
          if (event.key === 'ArrowRight') moveByPage(1);
          if (event.key === 'Home') goToCard(0);
          if (event.key === 'End') goToCard(maxStartIndex());
        });

        viewport.addEventListener('scroll', () => {
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(updateState);
        }, { passive: true });

        const resizeObserver = new ResizeObserver(measure);
        resizeObserver.observe(viewport);
        measure();
      });
    };

    initializeRecapCarousels();
    document.addEventListener('shopify:section:load', (event) => {
      initializeArchiveSelects(event.target);
      initializeRecapCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bar-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mobile-bar-hero__cta[href="#mobile-bar-inquiry"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const inquiry = document.getElementById('mobile-bar-inquiry');
    if (!inquiry) return;
    event.preventDefault();
    inquiry.setAttribute('tabindex', '-1');
    inquiry.focus({ preventScroll: true });
    inquiry.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start'
    });
  });

  } catch(e) { console.error(e); }
})();
})();
